import React from "react";
import { Text, View } from "react-native";
import { STYLES } from "../assets/styles";

function Logo({ size = STYLES.fontSizes.xxlarge, color = "black" }) {
  return (
    <View style={{ flexDirection: "row" }}>
      <Text style={{ fontSize: size * 2, color: color, fontWeight: "300" }}>
        Style
      </Text>
      <Text style={{ fontWeight: "bold", fontSize: size * 2, color: color }}>
        ON
      </Text>
    </View>
  );
}

export default Logo;
